import styled from 'styled-components'
import ImgUtil from '../../../utils/img.utils'

export const MainNavBannerContainer = styled.li<{
  $backgroundTheme: string
  $useCase: string
  $navType: string
}>`
  ${({ theme, $backgroundTheme, $useCase, $navType }) => {
    let themeStyles = ''

    if ($backgroundTheme === 'orange' || $backgroundTheme === 'dark') {
      themeStyles = `
        background: ${
          $backgroundTheme === 'orange'
            ? theme.webMktNewPalette.orange[50]
            : theme.webMktNewPalette.deepBlue[70]
        };

        p {
          color: ${theme.webMktNewPalette.white};
        }

        ${
          $backgroundTheme === 'orange'
            ? `
              .MainNavBanner__CTA.MainNavBanner__CTA {
                color: ${theme.webMktNewPalette.white};

                &:hover {
                  color:  ${theme.webMktNewPalette.white};
                }
              };
            `
            : ''
        }
      `
    } else {
      //* grey and light theme
      themeStyles = `
        ${
          $backgroundTheme === 'grey'
            ? `
          background: ${theme.webMktNewPalette.deepBlue[10]};
          `
            : ''
        }

        .MainNavBanner__Title {
          color: ${theme.webMktNewPalette.action.light.primary};
        }
      `
    }

    let useCaseStyles = ''
    if ($useCase === 'Image Text') {
      useCaseStyles = `
        .MainNavBanner__CTA {
          margin-top: 16px;
        }
      `
    } else {
      useCaseStyles = `
        .MainNavBanner__CTA.MainNavBanner__CTA {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      `
    }

    let maxWidth = $useCase === 'Text only' ? '800px' : $useCase === 'Icon Text' ? '744px' : '787px'

    let newNavStyle = ''
    if ($navType === 'New Nav') {
      newNavStyle += `
        align-self: stretch;
        flex: 1;
        padding: 24px;

        .MainNavBanner__Image-Container {
          margin-top: 8px;
          margin-bottom: 24px;
          width: 100%;
        }

        .MainNavBanner__Title {
          margin-bottom: 12px;
        }

        ${theme.breakpoints.down('lg')} {
          padding: 16px;
        }

        ${theme.breakpoints.down('md')} {
          padding: 0;

          .MainNavBanner__Image-Container {
            width: 160px;
          }
        }
      `
    }

    return `
      ${themeStyles}
      ${useCaseStyles}

      ${theme.breakpoints.down('sm')} {
        display: none;
      }

      .MainNavBanner__Content {
        max-width: ${maxWidth};
        padding: 16px 0;
      }

      .MainNavBanner__Image-Container {
         height: ${$useCase == 'Image Text' ? '100%' : '32px'};
         width: ${$useCase == 'Image Text' ? '213px' : '32px'};
      }

      list-style: none;
      border-top: 1px solid #e5e5e5;

      ${newNavStyle}
    `
  }}

  > a {
    padding: 0 16px;
    display: block;
  }

  p {
    margin: 0;
  }

  .MainNavBanner__Inner-Container {
    margin: 0 auto -8px;
    display: flex;
    flex-direction: ${({ $navType }) => ($navType === 'New Nav' ? 'column' : 'row')};
    align-items: center;
    max-width: 1200px;
    position: relative;
  }

  .MainNavBanner__Promo-Card-Link {
    position: absolute;
    width: calc(100% - 16px);
    height: 100%;
    top: 0px;
  }

  .MainNavBanner__Image-Container {
    margin-right: ${({ $navType }) => ($navType === 'New Nav' ? '0' : '24px')};

    img {
      width: auto;
      max-width: 100%;
      margin: 0 auto;
      display: block;
    }
  }
`

//* new nav code
export const NewNavBannerContainer = styled.div<{
  $useCase: string
  $backgroundImgSrc: string
  $displayCta: string
  $textAlignment: string
}>`
  display: flex;
  flex-direction: column;
  padding: 32px;
  width: calc(100% - 64px);

  .MainNavBanner__Inner-Container {
    ${({ $useCase, $backgroundImgSrc }: any) => {
      const customXLBreakpoint = 1535
      const customLGBreakpoint = 1390
      const customMDBreakpoint = 1260

      return $useCase === 'Text Above'
        ? `
        background-image: url(${ImgUtil.getResizedImageUrl($backgroundImgSrc, '')});
        background-size: cover;
        background-position-y: -120px;
        background-repeat: no-repeat;
        max-height: 263.25px;

        @media (max-width: ${customXLBreakpoint}px) {
          background-position-y: -80px;
        }

        @media (max-width: ${customLGBreakpoint}px) {
          background-position-y: -40px;
        }

        @media (max-width: ${customMDBreakpoint}px) {
          background-position-y: 0;
        }
      `
        : 'none'
    }};

    width: 100%;
    padding: 0;
    position: relative;
  }
  .MainNavBanner__Promo-Card-Link {
    position: absolute;
    width: calc(100% - 16px);
    height: 100%;
    top: 0px;
  }
  .MainNavBanner__Image-Container {
    margin-bottom: 24px;
  }

  .MainNavBanner__Content {
    text-align: ${({ $textAlignment }) => ($textAlignment === 'Centered' ? 'center' : 'left')};

    .MainNavBanner__Eyebrow {
      margin-top: ${({ useCase }: any) => (useCase === 'Text Above' ? '24px' : 0)};
      font-size: 13px;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: ${({ theme }) => theme.webMktNewPalette.deepBlue[60]};
    }

    .MainNavBanner__Title {
      margin-bottom: 12px;
    }

    .MainNavBanner__Subtitle {
      margin-bottom: 12px;
      color: ${({ theme }) => theme.webMktNewPalette.deepBlue[60]};
    }

    .MainNavBanner__Description {
    }

    .MainNavBanner__CTA {
      font-family: ${({ theme }) => theme.webMktTypography.fontFamilyName.poppins};
      color: ${({ theme }) => theme.webMktNewPalette.black};
      font-size: ${({ theme }) => theme.webMktTypography.fontSizes[2]};
      font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.bold};
      line-height: 20px;
      span {
        font-family: ${({ theme }) => theme.webMktTypography.fontFamilyName.poppins};
      }
      &:hover {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      }

      .CTA__Arrow-Container {
        margin-left: 8px;

        &::before {
          font-size: ${({ theme }) => theme.webMktTypography.fontSizes[4]};
        }
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`
